"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueCell = exports.HeaderName = exports.HeaderCell = exports.ResultsTable = exports.ResultsScroller = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
// A coil can return close to thirty results, so the table is wider than the pane and scrolls
// sideways rather than wrapping. The names and the units stay put while it does.
exports.ResultsScroller = styled_components_1.default.div `
  overflow-x: auto;
  max-width: 100%;
`;
exports.ResultsTable = styled_components_1.default.table `
  border-collapse: collapse;
  white-space: nowrap;

  thead th {
    border-bottom: 1px solid #aaa;
  }

  tbody tr:nth-child(even) {
    background-color: #f7f7f7;
  }
`;
// The name and the unit selector share one heading, so a column is named and re-scaled in the
// same place.
exports.HeaderCell = styled_components_1.default.th `
  padding: 6px 12px;
  text-align: right;
  vertical-align: bottom;
  font-weight: normal;
  white-space: nowrap;
`;
exports.HeaderName = styled_components_1.default.span `
  font-weight: bold;
  margin-right: 4px;
`;
exports.ValueCell = styled_components_1.default.td `
  padding: 4px 12px;
  text-align: right;
`;
//# sourceMappingURL=elements.js.map